globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
export var ClipIcon = function ClipIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.1725 7.00001L8.58651 13.586C8.39549 13.7705 8.24312 13.9912 8.13831 14.2352C8.03349 14.4792 7.97831 14.7417 7.97601 15.0072C7.9737 15.2728 8.0243 15.5361 8.12486 15.7819C8.22543 16.0277 8.37393 16.251 8.56172 16.4388C8.7495 16.6266 8.97281 16.7751 9.2186 16.8757C9.46439 16.9762 9.72775 17.0268 9.99331 17.0245C10.2589 17.0222 10.5213 16.967 10.7653 16.8622C11.0093 16.7574 11.23 16.605 11.4145 16.414L17.8285 9.82801C18.5571 9.0736 18.9603 8.06319 18.9512 7.01441C18.9421 5.96562 18.5214 4.96237 17.7798 4.22074C17.0381 3.4791 16.0349 3.05843 14.9861 3.04932C13.9373 3.0402 12.9269 3.44338 12.1725 4.17201L5.75751 10.757C4.63219 11.8823 4 13.4086 4 15C4 16.5914 4.63219 18.1177 5.75751 19.243C6.88282 20.3683 8.40907 21.0005 10.0005 21.0005C11.5919 21.0005 13.1182 20.3683 14.2435 19.243L20.5005 13",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};